import clsx from 'clsx';
import { FC } from 'react';

type NavbarBurgerButtonProps = {
  toggleMobileMenu: VoidFunction;
  isMobileMenuOpen: boolean;
}

export const NavbarBurgerButton: FC<NavbarBurgerButtonProps> = ({
  toggleMobileMenu,
  isMobileMenuOpen,
}) => (
  <button
    type="button"
    className="font-objektiv relative z-50 flex size-10 flex-col items-center justify-center tracking-[3px] text-white focus:outline-none"
    onClick={toggleMobileMenu}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleMobileMenu();
      }
    }}
    aria-label="Toggle mobile menu"
    aria-expanded={isMobileMenuOpen}
  >
    <div
      className={clsx(
        'absolute h-1 w-10 bg-[#f7eee2] transition-all duration-300 ease-in-out',
        isMobileMenuOpen ? 'translate-y-0 rotate-45' : '-translate-y-3',
      )}
    />
    <div
      className={clsx(
        'h-1 w-10 bg-[#f7eee2] transition-all duration-300 ease-in-out',
        isMobileMenuOpen ? 'opacity-0' : 'opacity-100',
      )}
    />
    <div
      className={clsx(
        'absolute h-1 w-10 bg-[#f7eee2] transition-all duration-300 ease-in-out',
        isMobileMenuOpen ? 'translate-y-0 -rotate-45' : 'translate-y-3',
      )}
    />
  </button>
);
